import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CryptoWalletComponent } from '@zero/self-service/feature-crypto-wallet/web';
import { IconComponent } from '@zero/shared/ui-web-design-system';

@Component({
  templateUrl: './krypto-wallet.component.html',
  selector: 'self-service-krypto-wallet',
  imports: [TranslocoPipe, CryptoWalletComponent, IconComponent],
})
export class KryptoWalletComponent {
  @Input() public showMe = false;
}
